<app-dialog
  [size]="DialogSize.SMALL"
  type="confirmation"
  [attr.data-cy]="(initialPaymentFailed ? 'failed-payment' : 'thanks') + '-modal'"
>
  <app-dialog-header
    class="border-0 bg-transparent"
    [ngClass]="{ 'confirmation-dialog-header-trimmed': errorMessageIncludesCustomContent }"
  >
    <p *ngIf="initialPaymentFailed" class="h2-500 color-red-300" data-cy="failed-modal-text">Payment Unsuccessful</p>
  </app-dialog-header>

  <div
    class="d-flex flex-column align-items-center px-6"
    [ngClass]="{
      'pt-4 pb-2': errorMessageIncludesCustomContent,
      'py-6': !errorMessageIncludesCustomContent && initialPaymentFailed,
      'pb-6': !initialPaymentFailed
    }"
  >
    <ng-container *ngIf="initialPaymentFailed; else successfulPaymentTemplate">
      <ng-container [ngSwitch]="data.payments.initial.error.message">
        <ng-container *ngSwitchCase="CustomContentErrorMessage.ACH_DISPUTE">
          <ng-container *ngTemplateOutlet="achDisputeTemplate"></ng-container>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <p>{{ displayMessage }}</p>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #successfulPaymentTemplate>
      <img src="assets/thanks@2x.png" width="146" height="146" alt="">

      <p class="h2-500 mt-6">Thanks for paying!</p>

      <p class="w-100 mt-6 fw--300">
        A confirmation email has been sent to
        <a type="email" [href]="'mailto:' + data.primaryEmail">{{ data.primaryEmail }}</a>.
      </p>

      <ng-container *ngIf="successfulPayments.length > 1">
        <p class="w-100 fw--500 mt-6 mb-2">
          Please note that {{ successfulPayments.length }} transactions will appear on your statement:
        </p>
        <div
          *ngFor="let successfulPayment of successfulPayments; let index = index"
          class="w-100 d-flex justify-content-between fw--300"
          [ngClass]="{ 'color-green-300': failedPayments.length > 0, 'mt-1': index > 0 }"
        >
          <p>{{ successfulPayment.name | variableTitleCase }}</p>
          <p>{{ successfulPayment.amount | currency }}</p>
        </div>
      </ng-container>

      <ng-container *ngIf="failedPayments.length > 0">
        <p class="w-100 fw--500 color-red-300 mt-6">
          Payment failed for {{ failedPayments.length }} transaction{{ failedPayments.length === 1 ? '' : 's' }}:
        </p>
        <div
          *ngFor="let failedPayment of failedPayments; let index = index"
          class="w-100 d-flex justify-content-between color-red-300 fw--300"
          [ngClass]="{ 'mt-1': index > 0 }"
        >
          <p>{{ failedPayment.name | variableTitleCase }}</p>
          <p>{{ failedPayment.amount | currency }}</p>
        </div>
      </ng-container>

      <p *ngIf="data.isQuickPayment" class="w-100 fw--300 mt-6">
        When you close this message, you’ll return to the payment form. You can submit another payment or close the tab if you're done.
      </p>
    </ng-template>
  </div>

  <!-- TODO: Ignoring for now -->
  @let isSuccessfulQuickPayment = data.isQuickPayment && !initialPaymentFailed && false;
  <app-dialog-footer [showCancel]="false" [equalWidthButtons]="isSuccessfulQuickPayment">
    @if (isSuccessfulQuickPayment) {
      <div class="w-100 d-flex justify-content-stretch gap-4">
        <button
          mat-dialog-close
          andButton
          color="secondary"
          size="large"
          class="payment-results-confirmation-button2"
          data-cy="make-another-payment-button"
        >
          Make another payment
        </button>

        <button
          andButton
          color="primary"
          size="large"
          class="payment-results-confirmation-button2"
          (click)="onLeave()"
          data-cy="leave-button"
        >
          Leave
        </button>
      </div>
    } @else {
      <div class="w-100 d-flex justify-content-center">
        <button
          mat-dialog-close
          andButton
          color="primary"
          size="large"
          class="payment-results-confirmation-button"
          [attr.data-cy]="(isSessionExpired ? 'reload' : initialPaymentFailed ? 'try-again' : 'close-modal') + '-button'"
          (click)="onConfirm()"
        >
          {{ confirmButtonText }}
        </button>
      </div>
    }
  </app-dialog-footer>
</app-dialog>

<ng-template #achDisputeTemplate>
  <div class="color-gray-100">
    <p class="small-300">{{ data.payments.initial.error.message }}</p>

    <p class="small-300 fw-bold mt-4">
      Please try a different payment method or follow the instructions below to remediate the issue.
    </p>

    <p class="small-300 mt-4">
      What is a Debit Block/Dispute? Some banking institutions and their clients opt to have a Debit Block for an added layer of security.
      Debit Blocks will automatically dispute transactions, which will cause a payment to fail either at checkout, or a day or two later.
    </p>

    <p class="small-300 mt-3">
      In order to fix this issue, please reach out to your bank to ensure you have added these Payee IDs as authorized for debits on your bank account:
    </p>

    <ul class="small-300 ul-indent">
      <li>1800948598 - Stripe Payments Company</li>
      <li>4270465600 - Stripe Payments Company</li>
    </ul>

    <p class="small-300 mt-3">
      Please reach out to
      <a type="email" [href]="'mailto:support@aiwyn.ai'">support&#64;aiwyn.ai</a>
      and confirm that there are no authorization restrictions applied to your bank account and future debits have been authorized.
    </p>

    <p class="small-300 mt-3">
      You can also visit our
      <button
        andButton
        color="hyperlink"
        size="small"
        role="link"
        class="color-gray-100 p-0 w-fit-content fw-light d-inline-block"
        (click)="navigateToSupportArticle()"
      >
        support article
      </button>
      for a list of common banks that have debit blocks and how to add approved Payee IDs.
    </p>
  </div>
</ng-template>
